var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEstimate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.89169 2.90588C3.9425 1.85145 5.39461 1.2 7 1.2C10.2033 1.2 12.8 3.79675 12.8 7C12.8 10.2033 10.2033 12.8 7 12.8C3.79675 12.8 1.2 10.2033 1.2 7C1.2 6.66863 0.931371 6.4 0.6 6.4C0.268629 6.4 0 6.66863 0 7C0 10.866 3.13401 14 7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0C5.06281 0 3.30846 0.787697 2.0417 2.05882C2.02134 2.07925 2.00276 2.10077 1.98596 2.12321L0.979902 1.11716C0.870154 1.00741 0.706826 0.971054 0.560889 1.02389C0.414952 1.07673 0.312754 1.20922 0.298702 1.36378L0.0158591 4.47506C0.00511146 4.59328 0.0474318 4.71017 0.131374 4.79411C0.215316 4.87805 0.332206 4.92037 0.450431 4.90963L3.5617 4.62678C3.71627 4.61273 3.84876 4.51053 3.90159 4.3646C3.95443 4.21866 3.91808 4.05533 3.80833 3.94558L2.82584 2.96309C2.84881 2.94588 2.87083 2.92681 2.89169 2.90588Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.6 3C7.6 2.66863 7.33137 2.4 7 2.4C6.66863 2.4 6.4 2.66863 6.4 3V7C6.4 7.20687 6.50657 7.39916 6.682 7.5088L9.082 9.0088C9.363 9.18443 9.73317 9.099 9.9088 8.818C10.0844 8.537 9.999 8.16683 9.718 7.9912L7.6 6.66745V3Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEstimate);
export default __webpack_public_path__ + "static/media/estimate.a2c3ffd0d1dca3b610e8058438dcbb4d.svg";
export { ForwardRef as ReactComponent };